module.exports = __webpack_public_path__ + "img/updateImg1.20aace89.png";